// extracted by mini-css-extract-plugin
module.exports = {"container":"RemoveExpirationActionButtons_container__2tCcD","buttons":"RemoveExpirationActionButtons_buttons__DSWrH"};